import React, { useEffect, useMemo, useState } from 'react';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { States } from '@/helpers/common/states';
import CommunicationType from '@/model/CommunicationType';
import Communication from '@/model/Communication';
import { Column } from '@/components/TableReponsive';
import { useHistory } from 'react-router-dom';
import { CommunicationListUI } from './ui';
import { communicationService } from '../../services';

const getChannelLabel = (channel: CommunicationType): string => {
  switch (channel) {
    case CommunicationType.WHATSAPP:
      return 'WhatsApp';
    case CommunicationType.EMAIL:
      return 'E-mail';
    case CommunicationType.PUSH_NOTIFICATION:
      return 'Notificação';
    default:
      return '-';
  }
};

export const CommunicationListScreen: React.FC = (): JSX.Element => {
  const [state, setState] = useState<States>(States.default);
  const [communications, setCommunications] = useState<Communication[]>([]);
  const history = useHistory();
  const handleGetCommunications = async (): Promise<void> => {
    try {
      setState(States.loading);

      const data = await communicationService.list();
      setCommunications(data);
    } catch (error) {
      const err = error as AxiosError<{ message?: string }>;
      toast.error(err.response?.data?.message || err.message || 'Erro ao buscar campanhas');
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    handleGetCommunications();
  }, []);

  const getStateLabel = (row: Communication): string => {
    if (row.state) return row.state;
    if (row.locations?.length) return row.locations[0].state || '-';
    return '-';
  };

  const getCitiesLabel = (row: Communication): string => {
    if (row.cities?.length) return row.cities.join(', ');
    if (row.locations?.length) return row.locations.map(location => location.city).join(', ');
    return '-';
  };
  const columns = useMemo<Column<Communication>[]>(
    () => [
      {
        key: 'name',
        header: 'Campanha',
        width: 'minmax(220px, 2fr)',
        sortable: true,
      },
      {
        key: 'communicationChanel',
        header: 'Canais',
        width: 'minmax(180px, 1.5fr)',
        render: row => (row.channels?.length ? row.channels.map(getChannelLabel).join(', ') : '-'),
      },
      {
        key: 'state',
        header: 'Estado',
        width: '120px',
        sortable: true,
        render: row => getStateLabel(row),
      },
      {
        key: 'cities',
        header: 'Cidades',
        width: 'minmax(220px, 2fr)',
        render: row => getCitiesLabel(row),
      },
      {
        key: 'radius',
        header: 'Raio',
        width: '100px',
        align: 'center',
        sortable: true,
        render: row => `${row.radius ?? 0} km`,
      },
      {
        key: 'customerLimit',
        header: 'Qtd. mensagens',
        width: '140px',
        align: 'center',
        sortable: true,
        render: row => String(row.customerLimit ?? 0),
      },
      {
        key: 'event',
        header: 'Evento',
        width: 'minmax(220px, 1.5fr)',
        render: row => {
          const eventName = typeof row.event === 'string' ? row.event : '-';
          return String(eventName) || '-';
        },
      },
      {
        key: 'id',
        header: 'Ações',
        width: '140px',
        align: 'center',
        render: row => (
          <div className="d-flex justify-content-center gap-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={e => {
                e.stopPropagation();
                history.push(`/communication-detail/${row.id}`);
              }}
            >
              Ver
            </button>

            {/* <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={e => {
                e.stopPropagation();
                console.log('Editar campanha', row.id);
              }}
            >
              Editar
            </button> */}
          </div>
        ),
      },
    ],
    [],
  );

  return (
    <CommunicationListUI
      state={state}
      data={communications}
      columns={columns}
      onRefresh={handleGetCommunications}
      onRowClick={row => {
        console.log('clicou na linha', row);
      }}
    />
  );
};
